import { Routes } from '@angular/router';
import { RouterModule } from '@angular/router';
import {NgModule} from '@angular/core';
import {StepChapterComponent} from '../step/step.chapter.component';
import {EinstiegComponent} from './einstieg/einstieg.component';
import {EingabeStartComponent} from './eingabe/eingabe.start.component';
import {EingabeStepComponent} from './eingabe/eingabe.step.component';
import {ErgebnisComponent} from './ergebnis/ergebnis.component';
import {PortalService} from '../services/portal.service';
import {ThermostatcheckAusstiegComponent} from "./eingabe/thermostatcheck.ausstieg.component";
import {AdvisorPagenotfoundComponent} from "../advisor.pagenotfound.component";

/**
 * Routes for the thermostatcheck.
 * The default route leads to thermostatcheck here
 */
const routes: Routes = [
  { path: ':portalId/thermostatcheck', children: [
      // default step is 'eingabe'
      { path: '', redirectTo: 'start', pathMatch: 'full' },
      // short version of the advisor
      { path: 'kurz', component: EinstiegComponent},

      // regular version of advisor
      { path: 'start', component: EingabeStartComponent},
      {path: 'eingabe/start', redirectTo: 'start', pathMatch: 'full'},

      // first input section
      { path: 'eingabe', component: StepChapterComponent, children: [
          { path: 'basisdaten/1', component: EingabeStepComponent, data: {swipeCount: '20'}},
          { path: 'basisdaten/2', component: EingabeStepComponent, data: {swipeCount: '30'}},
          { path: 'basisdaten/3', component: EingabeStepComponent, data: {swipeCount: '40'}},
          { path: 'basisdaten/4', component: EingabeStepComponent, data: {swipeCount: '50'}},

          { path: 'ausstieg', component: ThermostatcheckAusstiegComponent, data: {swipeCount: '60', ignoreInNav: true, isDeadEnd: true}},

          { path: '', redirectTo: 'basisdaten/1', pathMatch: 'full' },
        ]},
      // last section with result page
      { path: 'ergebnis', component: StepChapterComponent, children: [
          { path: 'analyse', component: ErgebnisComponent, data: {swipeCount: '1000', advisor: 'thermostatcheck'}},
          { path: '', redirectTo: 'analyse', pathMatch: 'full' },
        ]},
    ]},
  {path: ':portalId', redirectTo: PortalService.defaultPortal + '/thermostatcheck', pathMatch: 'full'},
  {path: 'thermostatcheck/', redirectTo: PortalService.defaultPortal + '/thermostatcheck', pathMatch: 'full'},
  {path: '', redirectTo: PortalService.defaultPortal + '/thermostatcheck', pathMatch: 'full'},
  {path: '**', pathMatch: 'full', component: AdvisorPagenotfoundComponent, data: {advisor: 'thermostatcheck'}}

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollOffset: [0, 150],
    paramsInheritanceStrategy: 'always'
})],
  exports: [RouterModule]
})
export class ThermostatcheckRoutingModule { }
